import { InfoItem } from './InfoItem'
import { Info, LowerCaseText, BoldText } from './style'

export const InfoLine: any = Info

InfoLine.InfoItem = InfoItem
InfoLine.LowerCaseText = LowerCaseText
InfoLine.BoldText = BoldText
